import api from "../services/apiService";

// Notice board API (server: routes/noticeRoutes.js). Reading is open to every role; writing is HR/admin only.

export const fetchNotices = async (params) => (await api.get("/notices", { params })).data;
export const fetchNoticeSummary = async () => (await api.get("/notices/summary")).data;
export const fetchNotice = async (id) => (await api.get(`/notices/${id}`)).data;
export const fetchNoticeReceipts = async (id) => (await api.get(`/notices/${id}/receipts`)).data;
export const markNoticeRead = async (id) => (await api.post(`/notices/${id}/read`)).data;
export const acknowledgeNotice = async (id) => (await api.post(`/notices/${id}/acknowledge`)).data;
export const setNoticePinned = async (id, pinned) => (await api.put(`/notices/${id}/pin`, { pinned })).data;
export const deleteNotice = async (id) => (await api.delete(`/notices/${id}`)).data;
// Fresh { url, downloadUrl } for an attachment (signed links in a notice expire after 6 hours).
export const fetchNoticeAttachmentUrl = async (attachmentId) =>
  (await api.get(`/notices/attachments/${attachmentId}/url`)).data;

// `fields` are the notice's form values; `files` are new File objects; `removeAttachmentIds` (edit only).
const toFormData = (fields, files = [], removeAttachmentIds = []) => {
  const form = new FormData();
  Object.entries(fields).forEach(([key, value]) => form.append(key, value ?? ""));
  if (removeAttachmentIds.length) form.append("removeAttachmentIds", JSON.stringify(removeAttachmentIds));
  files.forEach((file) => form.append("files", file, file.name));
  return form;
};

export const createNotice = async (fields, files, onProgress) =>
  (
    await api.post("/notices", toFormData(fields, files), {
      onUploadProgress: (e) => onProgress?.(e.total ? e.loaded / e.total : 0),
    })
  ).data;

export const updateNotice = async (id, fields, files, removeAttachmentIds, onProgress) =>
  (
    await api.put(`/notices/${id}`, toFormData(fields, files, removeAttachmentIds), {
      onUploadProgress: (e) => onProgress?.(e.total ? e.loaded / e.total : 0),
    })
  ).data;
